"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOfferItem = updateOfferItem;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _constants = require("../constants");
var _deleteOfferItem = require("./deleteOfferItem");
async function updateOfferItem(params) {
  const {
    client,
    itemCode,
    offerId,
    placement,
    quantity,
    referer,
    sessionId,
    tenant,
    xPlacement
  } = params;
  if (quantity === 0) {
    return (0, _deleteOfferItem.deleteOfferItem)(params);
  }
  const globalShoppingOfferChoiceDtoBody = {
    itemCode,
    quantity
  };
  const headers = {
    [_fetching.TENANT_CONTEXT]: tenant
  };
  const usedPlacement = xPlacement === undefined ? placement : xPlacement;
  // omit both x-placement and x-referer headers if no usable placement was provided
  if (usedPlacement) {
    headers[_fetching.PLACEMENT] = usedPlacement;
    headers[_constants.REFERER] = referer;
  }
  return (0, _globalApiClientReact.updateShoppingSessionOfferChoice)(client, sessionId, offerId, itemCode, globalShoppingOfferChoiceDtoBody, headers);
}
